import * as React from "react";
import * as _ from "underscore";

// TabbedContent accepts a list of children identified by their `tabKey`.
// It uses the property `selectedTab` to render the matching child.
// Best used together with a TabbedControl.
//
// The component itself must have the following prop:
//
//   selectedTab: 'abc'  (the key of the tab element)
//
// The CHILD elements are the tabs, they are expected to have
// the following props:
//
//   tabKey
//

const emptyElement = <div />;

export interface TabbedContentProps {
  selectedTab: string;
  children: any[];
}

const TabbedContent = ({ selectedTab, children }: TabbedContentProps) => {
  const comp = _.detect(children, (d) => d.props.tabKey === selectedTab);

  if (comp != null) {
    if (comp.props.visible != null) {
      if (comp.props.visible) {
        return comp;
      } else {
        return emptyElement;
      }
    } else {
      return comp;
    }
  } else {
    return emptyElement;
  }
};

export default TabbedContent;
